import React, { useState } from "react";
import {
  Typography,
  Grid,
  Container,
  Collapse,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button
} from "@material-ui/core";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { goBackToAdminView, logOut } from "../../store/actions";
import "./sub.minify.css";
import SubImage from "../../assets/images/sub.png";

const SubscriptionErrorPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const account = useSelector((state) => state.account);

  const [open, setOpen] = useState(true);
  const [salesOpen, setSalesOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logOut());
    history.push("/");
  };

  const handleAdminView = () => {
    dispatch(goBackToAdminView());
    history.push("/");
  };

  return (
    <div className="subscription-bg">
      <Container maxWidth="md" className="glass-card">
        <div className="content-row">

          {/* LEFT PANEL */}
          <div className="left-section">
            <Typography variant="h2" className="title">
              🚫 Subscription Required
            </Typography>

            <Typography variant="h3" className="description">
              Your current account does not have access to the NBSense Dashboard.
              Activate or upgrade your plan to continue using live monitoring and analytics.
            </Typography>

            {/* SUPPORT CONTACT */}
            <div className="contact-box">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                  flexWrap: "wrap"
                }}
              >
                {/* CLICK TO CALL */}
                <Typography
                  variant="h4"
                  style={{
                    cursor: "pointer",
                    textDecoration: "underline"
                  }}
                  onClick={() => window.open("tel:+919049048044")}
                >
                  📞 Call Us - +91 904 904 8044
                </Typography>

                {/* CLICK TO WHATSAPP */}
                <Typography
                  variant="h4"
                  style={{
                    cursor: "pointer",
                    color: "#25D366",
                    textDecoration: "underline"
                  }}
                  onClick={() =>
                    window.open("https://wa.me/919619419288", "_blank")
                  }
                >
                  💬 Connect on WhatsApp - +91 961 941 9288
                </Typography>
              </div>
            </div>

            {/* CTA BUTTONS */}
            <Grid container spacing={2} className="cta-block">
              <Grid item xs={12} sm={6}>
                <Button
                  fullWidth
                  variant="contained"
                  className="sales-btn"
                  onClick={() => setSalesOpen(true)}
                >
                  Contact Sales
                </Button>
              </Grid>

              {account?.admin !== null && (
                <Grid item xs={12} sm={6}>
                  <Button
                    fullWidth
                    variant="outlined"
                    className="admin-btn"
                    onClick={handleAdminView}
                  >
                    Admin View
                  </Button>
                </Grid>
              )}

              <Grid item xs={12}>
                <Button
                  fullWidth
                  variant="outlined"
                  className="home-btn"
                  onClick={() => history.push("/")}
                >
                  Home
                </Button>
              </Grid>
            </Grid>

            {/* WHY SECTION */}
            <div className="why-box">
              <div
                className="why-header"
                onClick={() => setOpen(!open)}
              >
                <Typography variant="subtitle1">
                  Why am I seeing this?
                </Typography>
                <span>{open ? "▲" : "▼"}</span>
              </div>

              <Collapse in={open}>
                <ul className="why-list">
                  <li>Trial period is over.</li>
                  <li>Subscription expired or payment failed.</li>
                  <li>Your email is not mapped to an active client account.</li>
                </ul>

                <Typography variant="body2" className="support-text">
                  Contact our team using the options above and we'll quickly link
                  your account to the correct subscription.
                </Typography>
              </Collapse>
            </div>

            <Button fullWidth className="logout-btn" onClick={handleLogout}>
              Logout
            </Button>
          </div>

          {/* RIGHT PANEL */}
          <div className="right-section">
            <img
              src={SubImage}
              alt="Subscription Illustration"
              className="side-image"
            />
          </div>
        </div>
      </Container>

      {/* SALES EMAIL POPUP */}
      <Dialog open={salesOpen} onClose={() => setSalesOpen(false)}>
        <DialogTitle style={{ fontSize: "1.6rem", fontWeight: 600 }}>
          📩 Contact Sales
        </DialogTitle>

        <DialogContent>
          <Typography
            style={{
              fontSize: "1.2rem",
              marginBottom: "10px"
            }}
          >
            Please contact us at:
          </Typography>

          <Typography
            style={{
              fontSize: "1.6rem",
              fontWeight: 700,
              letterSpacing: "0.5px"
            }}
          >
            sales@nbri.in
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setSalesOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

    </div>
  );
};

export default SubscriptionErrorPage;
